<template>
  <div style="text-align: left">
    <div style="margin-bottom: 10px">
      <!--<el-button type="primary" class="add" size="small" @click="addTeam">
        <i class="el-icon-plus"></i>
        新增代表队
      </el-button>
      <el-button type="danger" size="small" class="delete" @click="delMulData">
        <i class="el-icon-delete"></i>删除
      </el-button>-->
    </div>
    <div>
      <div class="box">
        <el-form :inline="true" size="mini">
          <el-form-item>
            <el-input
              placeholder="请输入代表队名称"
              clearable
              v-model="searchForm.name"
            ></el-input>
          </el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="doSearch"
            class="queryBtn"
            >查询</el-button
          >

          <el-button
            type="warning"
            size="small" icon="el-icon-upload2"
            @click="showUploadDialog"
            >上传</el-button
          >
        </el-form>
      </div>
    </div>
    <el-table
      ref="multipleTable"
      :data="tableListData"
      tooltip-effect="dark"
      style="width: 100%; position: relative"
      :row-class-name="tableRowClassName"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        min-width="40"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="name"
        align="center"
        label="代表队名称"
      ></el-table-column>
      <el-table-column
        prop="caption"
        align="center"
        label="领队"
      ></el-table-column>
      <el-table-column
        prop="coach"
        align="center"
        label="教练"
      ></el-table-column>
      <el-table-column
        prop="mobile"
        align="center"
        label="联系电话"
      ></el-table-column>
      <el-table-column
        prop="operation"
        label="操作"
        width="200"
        fixed="right"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-popconfirm
            v-if="scope.row.isEnable"
            title="停用代表队？"
            @confirm="disableTeam(scope.row)"
          >
            <el-button type="text" size="mini" class="btnopt" slot="reference"
              >停用</el-button
            >
          </el-popconfirm>
          <el-popconfirm
            v-if="!scope.row.isEnable"
            title="启用代表队？"
            @confirm="enableTeam(scope.row)"
          >
            <el-button type="text" class="btnopt" size="mini" slot="reference"
              >启用</el-button
            ></el-popconfirm
          >

          <el-button
            type="text"
            size="small"
            @click="editTeam(scope.row)"
            class="btnopt"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[15, 20, 50, 100]"
        :page-size="searchForm.pageSize"
        background
        layout="prev, pager, next,total, sizes, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog
      :title="'代表队管理'"
      :inline="true"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        :model="form"
        label-position="right"
        label-width="110px"
        :rules="formRules"
        ref="form"
      >
        <el-form-item label="代表队名称" prop="name">
          <el-input v-model="form.name" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="领队" prop="caption">
          <el-input v-model="form.caption" maxlength="255"></el-input>
        </el-form-item>
         <el-form-item label="教练" prop="coach">
          <el-input v-model="form.coach" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="form.mobile" maxlength="255"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="isLoading"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog :title="'文件上传'" :inline="true" :visible.sync="dialogRuleVisible">
      <el-form size="small" label-position="right" label-width="110px">  
        <el-form-item label="所属代表队" prop="teamId">
          <el-select v-model="formUpload.teamId" @change="changeTeam">
            <el-option
              v-for="item in teamoptions"
              :value="item.value"
              :label="item.name"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>     
        <el-form-item prop="uploader">
          <el-upload ref="uploadRef" :http-request="uploadSecureFile" action="" :limit="1">
            <el-button type="primary">点击上传文件</el-button>
            <template #tip>
              <div class="el-upload__tip">请选择文件。</div>
            </template>
          </el-upload>
        </el-form-item>
        <el-card class="box-card" v-if="currentFile != null">
          <div class="text item" v-for="itemFile in currentFile">
            <div style="display: flex;margin: 10px 0px;">
              <div style="flex: 1;display: flex;">
                <div style="width: 70%;align-items: center;display: flex;">{{ itemFile.name }}</div>
              </div>
              <div style="align-items: center;display: flex;" title="删除附件"><i class="el-icon-delete" style="color: red;"
                  @click="deleteFile(itemFile.id)"></i></div>
            </div>
          </div>
        </el-card>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogRuleVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from '../apis/userteam'
import APIAttach from '../apis/teamattachment';
export default {
  data () {
    return {
      isLoading: false,
      dialogFormVisible: false,
      dialogRuleVisible:false,
      multipleSelection: [],
      total: 0,
      teamoptions: [],
      tableListData: [],
      searchForm: {
        name: null,
        page: 1,
        pageSize: 15,
      }, 
      formUpload: {
        teamId: 0,
      },
      form: {
        id: 0,
        name: '',
        caption: '',
        coach:'',
        mobile: ''
      },
      currentFile:[],
      formRules: {
        name: [{ required: true, message: '请输入代表队名称', trigger: 'blur' }],
        caption: [{ required: true, message: '请输入领队', trigger: 'blur' }],
        mobile: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
      }
    }
  },
  methods: {
    showUploadDialog() {
      this.dialogRuleVisible = true;
      this.formUpload.teamId = this.teamoptions[0].value;
      this.loadCurrentFile();
    },
    deleteFile(id) {
      this.$confirm("确认删除该文件附件吗？", "提示", { type: "warning" })
        .then(() => {
          APIAttach.del({ id: id }).then(res => {
            if (res.code == 0) {
              this.$message.success({
                showClose: true,
                message: "删除成功",
                duration: 2000,
              });
              this.currentFile = null
            } else {
              this.$message.error({
                showClose: true,
                message: res.message,
                duration: 2000,
              });
            }
          }).catch((error) => {
            this.$message.error({
              showClose: true,
              message: "系统错误",
              duration: 2000,
            });
          });
        })
        .catch(() => { });
    },
    changeTeam(val){
      this.formUpload.teamId=val;
      this.loadCurrentFile();
    },
    loadCurrentFile() {
            APIAttach.list(this.formUpload).then((res) => {
        this.currentFile = res.result;
      });
    }, 
    uploadSecureFile(param) {
      let that = this;
      this.isLoading = true;
      var fileObj = param.file;
      var formData = new FormData();
      formData.append('file', fileObj);
      formData.append('teamId', that.formUpload.teamId);
      APIAttach.upload(formData).then((res) => {
        if (res.code == 0) {
          that.$message.success({
            showClose: true,
            message: "附件上传成功",
            duration: 2000,
          });
          that.$refs.uploadRef.clearFiles();
          this.loadCurrentFile();
        } else {
          that.$message.error({
            showClose: true,
            message: res.message,
            duration: 2000,
          });
        }
      }).catch(error => {
        that.$message.error({
          showClose: true,
          message: '请求异常',
          duration: 2000,
        });
      })
    },
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return 'warning-row';
      } else {
        return 'success-row';
      }
    },
    editTeam (row) {
      this.formTitle = "编辑";
      API.get({ id: row.id }).then(result => {
        this.dialogFormVisible = true
        this.form = Object.assign({}, result.result)
      })
    },
    //新增部门表单弹框
    addTeam () {
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['form'].resetFields()
      })
    },
    handleSizeChange: function (val) {
      this.searchForm.pageSize = val;
      this.search()
    },
    handleCurrentChange: function (val) {
      this.searchForm.page = val;
      this.search()
    },
    doSearch () {
      this.searchForm.page = 1
      this.search()
    },
    enableTeam (row) {
      API.enable({ id: row.id }).then(result => {
        if (result.code == 0)
          this.$message.error({ showClose: true, message: '代表队已经启用', duration: 2000 });
      })
    },
    disableTeam (row) {
      API.disable({ id: row.id }).then(result => {
        if (result.code == 0)
          this.$message.error({ showClose: true, message: '代表队已经停用', duration: 2000 });
      })
    },
    search: function () {
      let params = Object.assign({}, this.searchForm);
      API.getList(params).then((result) => {
        if (result && result.code == 0) {
          this.tableListData = result.result.data;
          this.total = result.result.recordCount;
        }
        else {
          this.$message.error({ showClose: true, message: result.result.message, duration: 2000 });
        }
      }).catch((error) => {
        this.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 });
      });
    },

    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    submitForm () {
      let that = this;
      this.isLoading = true
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.form)
          if (params.id > 0) {
            API.edit(params).then((data) => {
              if (data.code == 0) {
                that.$message.success({ showClose: true, message: '更改成功', duration: 2000 });
                that.dialogFormVisible = false;
                that.$refs['form'].resetFields();
                that.search();
              } else {
                this.$message.error({ showClose: true, message: '更新失败', duration: 2000 });
              }
              that.isLoading = false
            }, function (err) {
              that.$message.error({ showClose: true, message: err.toString(), duration: 2000 });
              that.isLoading = false
            }).catch(function (error) {
              that.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 });
              that.isLoading = false
            })
          }
          else {
            API.add(params).then(result => {
              if (result.code == 0) {
                this.$message.success({ showClose: true, message: '新增成功', duration: 2000 });
                this.$refs['form'].resetFields();
                this.dialogFormVisible = false;
                this.search();
                this.isLoading = false
              } else {
                this.$message.error({ showClose: true, message: '新增失败', duration: 2000 });
                this.isLoading = false
              }
            }).catch((error) => {
              this.$message.error({ showClose: true, message: '请求异常', duration: 2000 });
              this.isLoading = false
            });
          }
        }
        else {
          this.isLoading = false
        }
      });
    },
    deleteTeam (row) {
      let params = { id: row.id };
      this.$confirm('确认删除记录吗？', '提示', { type: 'warning' }).then(() => {
        API.delete(params).then((result) => {
          console.log(result)
          if (result.code == 0) {
            this.$message.success({ showClose: true, message: '删除成功', duration: 2000 });
            this.search();
          } else {
            this.$message.error({ showClose: true, message: '系统错误', duration: 2000 });
          }
        }).catch((error) => {
          this.$message.error({ showClose: true, message: '123', duration: 2000 })
        })
      }).catch(() => { })
    },
    /*批量删除*/
    delMulData () {
      let that = this;
      let val = that.multipleSelection
      let idArray = [];
      for (var i = 0; i < val.length; i++) {
        idArray.push(val[i].id)
      }
      this.$confirm('此操作将永久删除该数据，是否继续？', '提示', {
        confimButtonTexe: '确定',
        cancelButtonTexe: '取消',
        type: 'warning'
      }).then(() => {
        if (idArray) {
          API.deleteBatch({ ids: idArray.join() }).then(function (result) {
            that.loading = false;
            if (result && result.code == 0) {
              that.$message.success({ showClose: true, message: '删除成功', duration: 2000 });
              that.search()
            } else {
              that.$message.error({ showClose: true, message: '删除操作异常，请重试', duration: 2000 });
            }
          }, function (err) {
            that.loading = false;
            that.$message.error({ showClose: true, message: err.toString(), duration: 2000 });
          }).catch(function (error) {
            that.loading = false;
            console.log(error);
            that.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 });
          })
        }
      })
      this.$refs.multipleTable.clearSelection()
    }
  },
  mounted () {
    this.search()
    API.select().then((res) => {
      this.teamoptions = res.result;
    });
  }
}
</script>


// WEBPACK FOOTER //
// src/components/TeamManagement.vue